webpackJsonp([242248167430603],{

/***/ 378:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>ИС Мемориал призвана обеспечить информационную составляющую бизнес-процесса по оказанию ритуальных и пост-ритуальных услуг.</p>","frontmatter":{"title":"ИС Мемориал","tabletImg":"","description":"Система информационного управления захоронениями на примере г. Казань.","participation":["Концепция проекта","Дизайн и разработка","Эксплуатация и сопровождение"],"href":"https://cemetery.kzn.ru/","statistics":["4 года успешной работы","Информация о сотнях тысяч захоронений на всех кладбищах г.Казань","Полный учёт всех захоронений начиная с 1995г"],"technologies":["html, css, sass","ruby, ruby-on-rails","angular","postgres"],"longDesktopImg":"","desktopImg":"","path":"/is-memorial/","files":null,"phoneImg":"","offerBtnHref":null,"offerBtnTitle":null,"offerDesc":null,"hideHref":null,"modulesTitle":null,"modules":null}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---is-memorial-3f064a100e1c4b7aed6b.js